export default __webpack_public_path__ + "static/media/icon-cross.41e3712e.svg";